<script setup lang="ts">
import { BALLOON_TEXT } from '@/constants/statesOfAddressSystem'

import type { SuggestedOfAddress } from '@/api/modules/geo/geocode.types'

type Props = { address: SuggestedOfAddress | null }

const props = defineProps<Props>()

const titleAddressOfMap = computed(() => {
  if (!props.address) return BALLOON_TEXT.default

  const { street, house, street_with_type } = props.address

  if (!street_with_type && !house) return BALLOON_TEXT.addressNotFound

  const existingStreet = street_with_type || street

  return formatToAddressSystem('', existingStreet, house)
})
</script>

<template>
  <div class="address-system-map-title">
    {{ titleAddressOfMap }}
  </div>
</template>

<style scoped lang="scss">
.address-system-map-title {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  color: var(--ui-secondary);
  text-align: center;
}
</style>
